

function ComingSoon() {
 

  return (
    <div className='outer-box'>
      <div className='title'>
        Address Plant
      </div>
      <div className='landing-brief'>
        Autopopulate Address Forms
      </div>
      <div className='landing-soon'>
        Coming Soon
      </div>
      
      
    </div>
  );
}

export default ComingSoon;
